var _rect, _path, _path2, _circle, _circle2, _circle3, _path3, _path4, _path5, _path6, _circle4, _circle5, _circle6, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardiovascular(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    fill: "#FFEDED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5278 56.4062C48.1024 56.9962 48.09 57.9403 47.5 58.5149L42.8723 63.0221C42.2823 63.5967 41.3382 63.5842 40.7636 62.9943C40.1889 62.4043 40.2014 61.4602 40.7914 60.8855L45.4191 56.3784C46.0091 55.8037 46.9532 55.8162 47.5278 56.4062Z",
    fill: "url(#paint0_linear_3823_25359)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1769 38.7286C53.1329 37.7593 66.0693 44.2275 70.543 47.5828C65.4169 57.9281 53.9158 76.4006 48.9202 67.5278C42.6757 56.4369 35.5924 55.4116 34.6604 55.132C33.7284 54.8524 27.4839 51.404 29.5343 45.0663C31.1747 39.9961 35.3128 38.7286 37.1769 38.7286Z",
    fill: "url(#paint1_linear_3823_25359)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.285,
    cy: 15.285,
    r: 15.285,
    transform: "matrix(-1 0 0 1 77.9062 45.3457)",
    fill: "#ADCFFC"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.1162,
    cy: 12.1162,
    r: 12.1162,
    transform: "matrix(-1 0 0 1 74.7422 48.5148)",
    fill: "white"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.557,
    cy: 11.557,
    r: 11.557,
    transform: "matrix(-1 0 0 1 74.1797 49.0741)",
    fill: "url(#paint2_radial_3823_25359)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.8125 14.7712C58.5325 15.1711 58.7918 16.079 58.3919 16.7989L55.5958 21.8318C55.1959 22.5518 54.288 22.8112 53.5681 22.4112C52.8481 22.0112 52.5887 21.1034 52.9887 20.3834L55.7848 15.3505C56.1847 14.6306 57.0926 14.3712 57.8125 14.7712Z",
    fill: "url(#paint3_linear_3823_25359)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.353 37.038C51.9233 36.4439 52.8673 36.4246 53.4614 36.9949L58.1215 41.4686C58.7156 42.039 58.7349 42.983 58.1645 43.5771C57.5942 44.1712 56.6502 44.1905 56.0561 43.6201L51.396 39.1464C50.8019 38.5761 50.7826 37.6321 51.353 37.038Z",
    fill: "url(#paint4_linear_3823_25359)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.7529 14.5831C51.5765 14.5831 52.2442 15.2508 52.2442 16.0744V21.1072C52.2442 21.9308 51.5765 22.5985 50.7529 22.5985C49.9294 22.5985 49.2617 21.9308 49.2617 21.1072V16.0744C49.2617 15.2508 49.9294 14.5831 50.7529 14.5831Z",
    fill: "url(#paint5_linear_3823_25359)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8427 18.7782C45.8866 17.8089 32.9502 24.2771 28.4766 27.6323C33.6026 37.9777 45.1037 56.4502 50.0993 47.5774C56.3438 36.4864 63.4271 35.4612 64.3591 35.1816C65.2911 34.902 71.5356 31.4535 69.4852 25.1158C67.8448 20.0457 63.7067 18.7782 61.8427 18.7782Z",
    fill: "url(#paint6_linear_3823_25359)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.3983,
    cy: 40.6804,
    r: 15.285,
    fill: "#FF6464"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.3935,
    cy: 40.6805,
    r: 12.1162,
    fill: "white"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.3968,
    cy: 40.6799,
    r: 11.557,
    fill: "url(#paint7_radial_3823_25359)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.79107,
    cy: 6.46946,
    rx: 9.79107,
    ry: 6.46946,
    transform: "matrix(-0.917701 0.397273 0.397273 0.917701 82.5547 41.6664)",
    fill: "#D63E46"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.25,
    cx: 6.8263,
    cy: 4.18867,
    rx: 6.8263,
    ry: 4.18867,
    transform: "matrix(-0.932148 0.362077 0.434529 0.900658 80.3398 43.7671)",
    fill: "#FFB1B1"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.35035,
    cy: 3.28302,
    rx: 5.35035,
    ry: 3.28302,
    transform: "matrix(-0.932148 0.362077 0.434529 0.900658 79.3555 45.1166)",
    fill: "#D33C44"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.3977,
    cy: 45.8715,
    rx: 8.40301,
    ry: 5.56082,
    transform: "rotate(-22.6907 22.3977 45.8715)",
    fill: "#D63E46"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.25,
    cx: 5.48874,
    cy: 3.6201,
    rx: 5.48874,
    ry: 3.6201,
    transform: "matrix(0.923734 -0.383034 0.388484 0.921456 15.5195 43.3287)",
    fill: "#FFB1B1"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.30199,
    cy: 2.43159,
    rx: 4.30199,
    ry: 2.43159,
    transform: "matrix(0.923734 -0.383034 0.388484 0.921456 16.918 43.5957)",
    fill: "#D33C44"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 65.5541,
    cy: 75.2775,
    rx: 6.38591,
    ry: 3.4733,
    transform: "rotate(35.3534 65.5541 75.2775)",
    fill: "#D63E46"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.25,
    cx: 5.44086,
    cy: 2.43749,
    rx: 5.44086,
    ry: 2.43749,
    transform: "matrix(0.830992 0.556285 -0.47022 0.882549 62.7969 69.5586)",
    fill: "#FFB1B1"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.26446,
    cy: 1.91046,
    rx: 4.26446,
    ry: 1.91046,
    transform: "matrix(0.830992 0.556285 -0.47022 0.882549 63.5273 70.6775)",
    fill: "#D33C44"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.3552,
    cy: 72.6418,
    rx: 10.5931,
    ry: 7.01014,
    transform: "rotate(40.7501 31.3552 72.6418)",
    fill: "#D63E46"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.25,
    cx: 32.4493,
    cy: 70.8589,
    rx: 6.31092,
    ry: 4.17635,
    transform: "rotate(40.7501 32.4493 70.8589)",
    fill: "#FFB1B1"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.4542,
    cy: 70.8578,
    rx: 4.94639,
    ry: 3.27335,
    transform: "rotate(40.7501 32.4542 70.8578)",
    fill: "#D33C44"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3823_25359",
    x1: 39.1967,
    y1: 63.9807,
    x2: 43.2975,
    y2: 60.3459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CA0D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C7DCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3823_25359",
    x1: 34.7536,
    y1: 54.2932,
    x2: 57.6812,
    y2: 32.8569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B7CCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84A5DB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3823_25359",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.6278 2.8846) rotate(122.057) scale(21.7741)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.565465,
    stopColor: "#2C69CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84A5DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3823_25359",
    x1: 57.5543,
    y1: 14.5835,
    x2: 54.9447,
    y2: 19.3368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F55A5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D33C44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3823_25359",
    x1: 54.852,
    y1: 40.6803,
    x2: 58.114,
    y2: 45.2472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D33C44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F55A5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3823_25359",
    x1: 50.7529,
    y1: 13.5579,
    x2: 50.7529,
    y2: 19.5228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F55A5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D33C44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3823_25359",
    x1: 64.2659,
    y1: 34.3428,
    x2: 41.3384,
    y2: 12.9065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D13A42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6464"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_3823_25359",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.7125 34.375) rotate(129.328) scale(25.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.342482,
    stopColor: "#C22A32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.941362,
    stopColor: "#FF6464"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardiovascular);
export default __webpack_public_path__ + "static/media/cardiovascular.7caa9ce0452fcbe72015befcca308466.svg";
export { ForwardRef as ReactComponent };